import { decamelize } from 'humps';
import adultIcon from '../images/brands/gfa/avatars/adult.png';
import minorIcon from '../images/brands/gfa/avatars/minor.png';
import studentIcon from '../images/brands/gfa/avatars/student.png';
import teacherIcon from '../images/brands/gfa/avatars/teacher.png';
import insenIcon from '../images/brands/gfa/avatars/old-adult.png';
import pcdIcon from '../images/brands/gfa/avatars/pcd.png';
import adultIconVariant from '../images/brands/etn/avatars/adult.png';
import minorIconVariant from '../images/brands/etn/avatars/minor.png';
import studentIconVariant from '../images/brands/etn/avatars/student.png';
import teacherIconVariant from '../images/brands/etn/avatars/teacher.png';
import insenIconVariant from '../images/brands/etn/avatars/old-adult.png';
import pcdIconVariant from '../images/brands/etn/avatars/pcd.png';
import { DEFAULT_PASSENGER_CATEGORY } from '../constants/passengerCategories';

const passengerTypes = {
  minor: {
    icon: minorIcon,
    iconVariant: minorIconVariant,
    label: 'type.minor_simple',
    disclaimer: 'selector.disclaimer_minor',
  },
  older: {
    icon: insenIcon,
    iconVariant: insenIconVariant,
    label: 'type.older',
    disclaimer: 'selector.disclaimer_older',
  },
  general: {
    icon: adultIcon,
    iconVariant: adultIconVariant,
    label: 'type.general',
  },
  adult: {
    icon: adultIcon,
    iconVariant: adultIconVariant,
    label: 'type.general',
  },
  student: {
    icon: studentIcon,
    iconVariant: studentIconVariant,
    label: 'type.student',
    disclaimer: 'selector.disclaimer_student',
  },
  teacher: {
    icon: teacherIcon,
    iconVariant: teacherIconVariant,
    label: 'type.teacher',
    disclaimer: 'selector.disclaimer_teacher',
  },
  pcd: {
    icon: pcdIcon || (!pcdIcon && null),
    iconVariant: pcdIconVariant || (!pcdIconVariant && null),
    label: 'type.special',
    disclaimer: 'selector.disclaimer_wheelchair_handicap',
  },
  wheelchair_handicap: {
    icon: null,
    iconVariant: null,
    label: 'category_wheelchair_handicap_seats',
    disclaimer: 'selector.disclaimer_wheelchair_handicap_seats',
  },
  pet_friendly: {
    icon: null,
    iconVariant: null,
    label: 'type.pet',
    disclaimer: 'selector.disclaimer_pet_friendly',
  },
};

/**
 * Bus categories mapped to the display entry whose icon and label represent them (`adult` shares
 * `general` so both collapse to one icon). The single source for every screen that shows a
 * passenger's category.
 */
export const PASSENGER_TYPE_DISPLAY_ALIASES = {
  adult: 'general',
  child: 'minor',
  child_in_arms: 'minor',
  disability: 'pcd',
  disability_half: 'pcd',
  disadvantaged_youth: 'student',
  disadvantaged_youth_half: 'student',
  federal_companion_free_pass: 'general',
  free_pass: 'general',
  infant: 'minor',
  intermunicipal_free_pass: 'older',
  older_half: 'older',
  senior: 'older',
  special: 'pcd',
};

/**
 * Returns the display entry (icon, icon variant, label) for a passenger's bus category.
 * Normalizes camelCase categories (e.g. `childInArms` from camelized purchase payloads) to
 * snake_case, applies PASSENGER_TYPE_DISPLAY_ALIASES and falls back to the default category's entry.
 * @param {string} [category] - Passenger bus category, e.g. 'senior', 'minor' or 'childInArms'.
 * @returns {{icon: string|null, iconVariant: string|null, label: string, disclaimer?: string}}
 */
export function getPassengerTypeByCategory(category) {
  const snakeCategory = typeof category === 'string' ? decamelize(category) : category;
  const normalizedCategory = PASSENGER_TYPE_DISPLAY_ALIASES[snakeCategory] || snakeCategory;

  return passengerTypes[normalizedCategory] || passengerTypes[DEFAULT_PASSENGER_CATEGORY];
}

export default passengerTypes;
